import {
  TDurationFilter,
  TFilterListSelected,
  TFilterSelected,
  TMultiSelectFilter,
  TOrgHeirachy,
  TSingleSelectFilter,
  TTargetDateFilter,
} from '@monorepo/types';

/**
 * Note: key will be deprected and replace with type after making type mandatory in all filters
 */
export const UTILS_GUARDS = {
  isSelectFilter: (filterOption: TFilterSelected): filterOption is TFilterListSelected => {
    return (
      (!filterOption?.type &&
        filterOption.key !== 'FACTORY_LOCATION_HIERARCHY' &&
        filterOption.key !== 'DURATION' &&
        filterOption.key !== 'TARGET_DATE' &&
        filterOption.key !== 'DELIVERY_DATE' &&
        filterOption.key !== 'delivery_date') ||
      filterOption.type === 'SELECT_FILTER'
    );
  },

  isMultiSelectFilter: (filterOption: TFilterSelected): filterOption is TMultiSelectFilter => {
    return (
      filterOption?.type === 'MULTI_SELECT_FILTER' ||
      (!filterOption.type &&
        (filterOption.key === 'FACTORY_ID_TO_NAME' || filterOption.key === 'factory_allocation_status'))
    );
  },

  isSingleSelectFilter: (filterOption: TFilterSelected): filterOption is TSingleSelectFilter => {
    return filterOption.type === 'SINGLE_SELECT_FILTER';
  },

  isOrgFilter: (filterOption: TFilterSelected): filterOption is TOrgHeirachy => {
    return filterOption?.type === 'ORG_HIERARCHY_FILTER' || filterOption.key === 'FACTORY_LOCATION_HIERARCHY';
  },

  isDurationFilter: (filterOption: TFilterSelected): filterOption is TDurationFilter => {
    return (
      filterOption?.type === 'DURATION_FILTER' ||
      filterOption.key === 'DURATION' ||
      filterOption.key === 'DELIVERY_DATE' ||
      filterOption.key === 'delivery_date'
    );
  },

  isTargetDateFilter: (filterOption: TFilterSelected): filterOption is TTargetDateFilter => {
    return filterOption?.type === 'DATE_FILTER' || filterOption.key === 'TARGET_DATE';
  },
};
